import styled from "styled-components";
import { screenWidth } from "~/config/dimensions";

export const Image = styled.img`
  position: absolute;
  width: ${(props) => screenWidth(props.width)}px;
  transform: ${(props) => props.rotate && "rotate(90deg)"};
`;
